module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b2S5r"))).then(() => parcelRequire('ljYL6'));